document.addEventListener("DOMContentLoaded", function () {
  // FAQ accordion starts

  const faq_items = document.querySelectorAll(
    ".accordion__container .accordion__button"
  );

  function toggleAccordion() {
    const faq_itemToggle = this.getAttribute("aria-expanded");
    const faqContent = this.nextElementSibling;
    this.parentElement.classList.add("active");

    const faq_item_siblings = Array.from(
      this.parentElement.parentElement.children
    );
    faq_item_siblings.forEach((sibling) => {
      if (sibling !== this.parentElement) {
        sibling.classList.remove("active");
        sibling.querySelector(".accordion_content").style.maxHeight = 0;
      }
    });

    for (let i = 0; i < faq_items.length; i++) {
      faq_items[i].setAttribute("aria-expanded", "false");
    }

    if (faq_itemToggle == "false") {
      this.setAttribute("aria-expanded", "true");
      faqContent.style.maxHeight = faqContent.scrollHeight + "px";
    } else {
      faqContent.style.maxHeight = 0;
    }
  }
  faq_items.forEach((item) => item.addEventListener("click", toggleAccordion));

  // FAQ accrodion ends

  // image cards js
  const ImageCardItems = document.querySelectorAll(".image_card_item");

  ImageCardItems.forEach((item) => {
    item.addEventListener("click", () => {
      ImageCardItems.forEach((sibling) => {
        if (sibling !== item) {
          sibling.classList.remove("active");
        }
      });
      item.classList.toggle("active");
    });
  });

  // hotspot section  js
  $(document).on("click", ".hotspot_media .hotspot_btn", function () {
    var activeContentId = $(this).data("content");

    $(".hotspot_media .hotspot_btn").removeClass("isActive");
    $(this).addClass("isActive");

    $(".hotspot_content").removeClass("active");
    $("#" + activeContentId).addClass("active");
  });

  $(document).on("click", ".hotspot_btn", function () {
    var activeContentId = $(this).data("content");
    var id = $(this).attr("data");
    $(".hotspot_btn").removeClass("isActive");
    $(`.hotspot_btn[data="${id}"]`).addClass("isActive");

    $(".hotspot_content").removeClass("active");
    $("#" + activeContentId).addClass("active");
  });
});

var swiper = new Swiper(".video_review_slider", {
  slidesPerView: 4,
  spaceBetween: 12,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 3,
    },
    575: {
      slidesPerView: 4,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});

// main product video popup
document.addEventListener("DOMContentLoaded", function () {
  const popupBtn = document.querySelector(".popup_btn");
  const modal = document.querySelector(".ctm_product_modal");
  const closeBtn = document.querySelector(".ctm_close_modal");
  const video = document.querySelector(".ctm_modal-content video");

  function isiPhone() {
    return /iPhone/i.test(navigator.userAgent);
  }
if(popupBtn){
  popupBtn.addEventListener("click", function () {
    // If it's an iPhone, open the video in full screen
    // if (isiPhone()) {
    //   video.play();
    // } else {
    // For other devices, show the popup
    document.querySelector(".ctm_product_modal_overlay").style.display =
      "block";
    modal.classList.add("active");
    video.play();
    // }
  });
}
if(closeBtn){
  closeBtn.addEventListener("click", function () {
    // if (isiPhone()) {
    //   video.pause();
    // } else {
    document.querySelector(".ctm_product_modal_overlay").style.display = "none";
    modal.classList.remove("active");
    video.pause();
    // }
  });
}

  const slides = document.querySelectorAll(
    ".video_review_slider .review_video_main"
  );
  const modalVideo = document.querySelector(".ctm_review_video_modal video");
  const reviewModal = document.querySelector(".ctm_review_video_modal");
  const ReviewCloseBtn = document.querySelector(
    ".ctm_review_video_modal .ctm_close_modal"
  );
  const ReviewVideo = document.querySelector(".ctm_review_video_modal video");

  slides.forEach((slide, index) => {
    slide.addEventListener("click", function () {
      const videoSource = slide
        .querySelector("video source")
        .getAttribute("src");
      modalVideo.src = videoSource;
      // if (isiPhone()) {
      //   ReviewVideo.play();
      // } else {
      document.querySelector(".ctm_product_modal_overlay").style.display =
        "block";
      reviewModal.classList.add("active");
      ReviewVideo.play();
      // }
    });

    ReviewCloseBtn.addEventListener("click", function () {
      // if (isiPhone()) {
      //   video.pause();
      // } else {
      document.querySelector(".ctm_product_modal_overlay").style.display =
        "none";
      reviewModal.classList.remove("active");
      modalVideo.pause();
      // }
    });
  });
});
